import React from 'react';
import ReactTooltip from 'react-tooltip';
import Questionmark from '../../assets/img/question-mark.svg';

export default function TooltipCheckoutLCR({ place = 'bottom', data: { retailer }, classAdded }) {
  return (
    <>
      <img
        data-event="click"
        className={`k-tooltip-icon ${classAdded}`}
        data-tip
        data-for="checkoutLCR"
        role="tooltip"
        src={Questionmark}
        alt="Tooltip Checkout LCR"
      />
      <ReactTooltip
        globalEventOff="click"
        clickable
        className="k-tooltip-theme k-tooltip-checkout-lcr"
        data-html
        id="checkoutLCR"
        place={place}
        effect="solid"
      >
        <div className="k-react-tooltip-totals">
          {`Because your cart is over your
          available limit, you can choose
          to make a lease cost reduction
          payment to cover the difference,
          similar to downpayment. It may
          not be refundable for items
          returned outside of `}
          <b>{retailer}&apos;s </b>
          return window.
        </div>
      </ReactTooltip>
    </>
  );
}
